import { render } from "./TheNavbar1.vue?vue&type=template&id=3ba34b64&scoped=true"
import script from "./TheNavbar1.vue?vue&type=script&lang=js"
export * from "./TheNavbar1.vue?vue&type=script&lang=js"

import "./TheNavbar1.vue?vue&type=style&index=0&id=3ba34b64&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba34b64"]])

export default __exports__